import React from 'react';

import I18n from '../../../lib/i18n';
import { IUnpackedRelatedProduct } from '../../../models/MessagePreview/UnpackedRelatedProduct';
import OunceRelatedProduct from './OunceRelatedProduct';

interface IProps {
  relatedProducts: IUnpackedRelatedProduct[];
}

const OunceRelatedProductList = (props: IProps) => {
  const { relatedProducts } = props;
  if (relatedProducts && relatedProducts.length !== 0) {
    const relatedProductsNodes = relatedProducts.map((relatedProduct, index) => (
      <OunceRelatedProduct relatedProduct={relatedProduct} key={index} />
    ));

    return (
      <div className="related-products">
        <div className="related-products-title">
          <i className="nxicon nxicon-shop" />
          <span className="related-products-title-text">{I18n.t('activerecord.attributes.message.related_products')}</span>
        </div>
        <div>
          {relatedProductsNodes}
        </div>
      </div>
    );
  }

  return null;
};

export default OunceRelatedProductList;
